import { createAction } from "redux-actions";

import { moduleSlug } from "../constants";

export const clearUsers = createAction(`${moduleSlug}/CLEAR_USERS`);

export const getUsers = createAction(`${moduleSlug}/GET_USERS`);
export const getUsersSuccess = createAction(`${moduleSlug}/GET_USERS/SUCCESS`);
export const getUsersError = createAction(`${moduleSlug}/GET_USERS/ERROR`);

export const getUserByID = createAction(`${moduleSlug}/GET_USERS_BY_ID`);
export const getUsersByIDSuccess = createAction(`${moduleSlug}/GET_USERS_BY_ID/SUCCESS`);
export const getUsersByIDError = createAction(`${moduleSlug}/GET_USERS_BY_ID/ERROR`);

export const createUser = createAction(`${moduleSlug}/CREATE_USER`);
export const createUserSuccess = createAction(`${moduleSlug}/CREATE_USER/SUCCESS`);
export const createUserError = createAction(`${moduleSlug}/CREATE_USER/ERROR`);

export const updateUser = createAction(`${moduleSlug}/UPDATE_USER`);
export const updateUserSuccess = createAction(`${moduleSlug}/UPDATE_USER/SUCCESS`);
export const updateUserError = createAction(`${moduleSlug}/UPDATE_USER/ERROR`);

export const deleteUser = createAction(`${moduleSlug}/DELETE_USER`);
export const deleteUserSuccess = createAction(`${moduleSlug}/DELETE_USER/SUCCESS`);
export const deleteUserError = createAction(`${moduleSlug}/DELETE_USER/ERROR`);